import {
  FETCH_SATISFACTION_SURVEY_SUCCESS,
  FETCH_SATISFACTION_SURVEY_ERROR,
  CREATE_SATISFACTION_SURVEY_SUCCESS,
  CREATE_SATISFACTION_SURVEY_ERROR,
} from 'constants/actionTypes'

const DEFAULT_STATE = {
  error: null,
  errorSave: null,
  dataSave: null,
  list: [],
  metadata: {},
}

const satisfactionSurveyReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_SATISFACTION_SURVEY_SUCCESS:
      return {
        ...state,
        error: null,
        errorSave: null,
        list: action.payload?.data ?? [],
        metadata: action.payload?.metadata ?? {},
      }

    case FETCH_SATISFACTION_SURVEY_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case CREATE_SATISFACTION_SURVEY_SUCCESS:
      return {
        ...state,
        dataSave: action.payload,
        errorSave: null,
      }

    case CREATE_SATISFACTION_SURVEY_ERROR:
      return {
        ...state,
        dataSave: null,
        errorSave: action.payload,
      }

    default:
      return state
  }
}

export default satisfactionSurveyReducer
